export enum LicenseModuleStatusEnum {
    Valid,
    CloseToExpiration,
    ExpiredRecently,
    Expired,
}
